import type {CommonDescriptionAttribute} from './CommonDescriptionAttribute';
import type {CommonFinancingPriceAttribute} from './CommonFinancingPriceAttribute';
import type {CommonGenerationAttribute} from './CommonGenerationAttribute';
import type {CommonMileageAttribute} from './CommonMileageAttribute';
import type {CommonPriceAttribute} from './CommonPriceAttribute';
import type {CommonPriceNoteAttribute} from './CommonPriceNoteAttribute';
import type {CommonTitleExtensionAttribute} from './CommonTitleExtensionAttribute';
import type {CommonVersionAttribute} from './CommonVersionAttribute';
import type {CommonVinAttribute} from './CommonVinAttribute';
import type {TipCarsPriceNoteAttribute} from './TipCarsPriceNoteAttribute';
import type {WindshieldContactEmailAttribute} from './WindshieldContactEmailAttribute';
import type {WindshieldContactPhoneAttribute} from './WindshieldContactPhoneAttribute';

export type VehicleAdvertisingAttributeRequestBody =
  | CommonTitleExtensionAttribute
  | CommonVinAttribute
  | CommonMileageAttribute
  | WindshieldContactEmailAttribute
  | WindshieldContactPhoneAttribute
  | CommonPriceAttribute
  | CommonFinancingPriceAttribute
  | CommonPriceNoteAttribute
  | TipCarsPriceNoteAttribute
  | CommonDescriptionAttribute
  | CommonVersionAttribute
  | CommonGenerationAttribute;
